module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-metodou-laseroveho-resurfacingu_2_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/vyhlazeni-vrasek-metodou-laseroveho-resurfacingu_2_before_tn.jpg
// module id = 1738
// module chunks = 0